import io from "socket.io-client";
import { nanoid } from 'nanoid'
let simSocket, hrmSocket, knlSocket, comDashSocket;
const listeners = [];
const localIP = "localhost";
const networkIP = process.env.VUE_APP_NETWORK_IP_SOCKET;
const networkIP_COMDASH = process.env.VUE_APP_NETWORK_IP_SOCKET_COMDASH;

const portSim = process.env.VUE_APP_PORT_SOCKET_SIMFONI;
const portHrm = process.env.VUE_APP_PORT_SOCKET_HARMONI;
const portKnl = process.env.VUE_APP_PORT_SOCKET_KANALA;
const portComDash = process.env.VUE_APP_PORT_SOCKET_COMM_DASH;

const localConnection = process.env.VUE_APP_NETWORK_LOCAL_CONNECTION;
const ssl = process.env.VUE_APP_WITH_SSL;
const socketEnable = process.env.VUE_APP_SOCKET_ENABLE;

function initialiseSocket() {

  if (!simSocket) {
    let url;
    if (ssl === "true") {
      url =
        localConnection === "true"
          ? "https://" + localIP + ":" + portSim
          : "https://" + networkIP + ":" + portSim;
    } else {
      url =
        localConnection === "true"
          ? "http://" + localIP + ":" + portSim
          : "http://" + networkIP + ":" + portSim;
    }
    simSocket = io(url);
  } else if (!hrmSocket) {
    let url;
    if (ssl === "true") {
      url =
        localConnection === "true"
          ? "https://" + localIP + ":" + portHrm
          : "https://" + networkIP + ":" + portHrm;
    } else {
      url =
        localConnection === "true"
          ? "http://" + localIP + ":" + portHrm
          : "http://" + networkIP + ":" + portHrm;
    }
    hrmSocket = io(url);
  } else if (!knlSocket) {
    let url;
    if (ssl === "true") {
      url =
        localConnection === "true"
          ? "https://" + localIP + ":" + portKnl
          : "https://" + networkIP + ":" + portKnl;
    } else {
      url =
        localConnection === "true"
          ? "http://" + localIP + ":" + portKnl
          : "http://" + networkIP + ":" + portKnl;
    }
    knlSocket = io(url);
  } else if (!comDashSocket) {
    let url;
    if (ssl === "true") {
      url =
        localConnection === "true"
          ? "https://" + localIP + ":" + portComDash
          : "https://" + networkIP_COMDASH + ":" + portComDash;
    } else {
      url =
        localConnection === "true"
          ? "http://" + localIP + ":" + portComDash
          : "http://" + networkIP_COMDASH + ":" + portComDash;
    }

    comDashSocket = io(url, {
      autoConnect: false,
      allowEIO3: true
    });
    comDashSocket.connect()
    const userActive = 'pandapakita.'+nanoid()
    comDashSocket.emit("newUser", {userActive, socketID: comDashSocket.id})
  }
}

export function simfoniListener(event) {
  if (socketEnable === "true") {
    initialiseSocket();
    if (!listeners.includes(event.type)) {
      simSocket.on(event.type, event.callback);
      listeners.push(event.type);
    }
  }
}

export function harmoniListener(event) {
  if (socketEnable === "true") {
    initialiseSocket();

    if (!listeners.includes(event.type)) {
      hrmSocket.on(event.type, event.callback);
      listeners.push(event.type);
    }
  }
}

export function kanalaListener(event) {
  if (socketEnable === "true") {
    initialiseSocket();

    if (!listeners.includes(event.type)) {
      knlSocket.on(event.type, event.callback);
      listeners.push(event.type);
    }
  }
}

export function commDashListener(event) {
  if (socketEnable === "true") {
    initialiseSocket();

    if (!listeners.includes(event.type)) {
      comDashSocket.on(event.type, event.callback);
      listeners.push(event.type);
    }
  }
}

export function sendEventSim(event) {
  if (socketEnable === "true") {
    if (event.hasOwnProperty("data")) {
      simSocket.emit(event.type, event.data);
      return;
    }

    simSocket.emit(event.type);
  }
}

export function sendEventHrm(event) {
  if (socketEnable === "true") {
    if (event.hasOwnProperty("data")) {
      hrmSocket.emit(event.type, event.data);
      return;
    }
    hrmSocket.emit(event.type);
  }
}

export function sendEventKnl(event) {
  if (socketEnable === "true") {
    if (event.hasOwnProperty("data")) {
      knlSocket.emit(event.type, event.data);
      return;
    }
    knlSocket.emit(event.type);
  }
}

export function sendEventComDash(event) {
  if (socketEnable === "true") {
    if (event.hasOwnProperty("data")) {
      comDashSocket.emit(event.type, event.data);
      return;
    }
    comDashSocket.emit(event.type);
  }
}
